import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { useLocalization } from "gatsby-theme-i18n"
import Article from "models/article"
import shuffle from "utils/shuffle"

const useCollectionArticles = ({ category, type, limit, order } = {}) => {
  const { locale } = useLocalization()

  const data = useStaticQuery(graphql`query AllCollectionArticlesQuery {
  articles: allCollectionArticles(sort: {date: DESC}) {
    nodes {
      id
      locale
      title
      date
      url
      category {
        title
        slug
      }
      type: articleType {
        title
        slug
      }
      authors {
        name
        avatar {
          url
        }
      }
      teaserExcerpt
      teaserImage {
        alt
        localImage {
          childImageSharp {
            gatsbyImageData(width: 400, height: 300)
          }
        }
      }
    }
  }
}`)

  /**
   * Get all Articles in the current locale
   * and apply filters if needed
   */
  return React.useMemo(() => {
    let articles = data.articles.nodes.filter(n => n.locale === locale)

    if (category) {
      articles = articles.filter(item => item.category.slug === category)
    }

    if (type) {
      articles = articles.filter(
        item => item.type && item.type.some(c => c.slug === type)
      )
    }

    switch (order) {
      case "random":
        articles = shuffle(articles)
        break

      case "oldest":
        articles.sort((a, b) => new Date(a.date) - new Date(b.date))
        break

      case "latest":
      default:
      // nothing to do, this is the natural order
    }

    if (limit) {
      articles = articles.slice(0, limit)
    }

    return articles.map(article => new Article(article))
  }, [data, locale, category, type, limit, order])
}

export default useCollectionArticles
